import { createContext, useState } from "react";

export const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [userToken, setUserToken] = useState(null);
  const [userId, setUserId] = useState(null);

  return (
    <>
      <UserContext.Provider value={{ userToken, setUserToken, userId, setUserId }}>
        {children}
      </UserContext.Provider>
    </>
  );
};

export default UserContextProvider;
